import { Record, Map } from 'immutable';

import { StreetParkingGeometries } from 'models/street-parking-geometry';

export default class StreetParkingSegment extends Record({
  id: null,
  geometries: null,
  availability: 'NoParking',
}) {
  constructor(props) {
    if (!props) {
      super();
      return;
    }

    const { id, state: availability } = props;
    const geometries = new StreetParkingGeometries(props.geometry);

    super({
      id,
      availability,
      geometries,
    });
  }

  get coordinates() {
    return this.geometries.map(g => [g.lng, g.lat]);
  }

  get color() {
    switch (this.availability) {
      case 'Available':
        return '#35f3f9';
      case 'Metered':
        return '#28357c';
      default:
        return '#e90404';
    }
  }
}

export const StreetParkingSegments = ((segments) => {
  const streetParkingSegments = {};
  if (segments && segments.length > 0) {
    segments.forEach((s) => { streetParkingSegments[s.id] = new StreetParkingSegment(s); });
  }

  return Map(streetParkingSegments);
});
